/** Dev overlay: in-run active play time + run index (day is on the progress dial). */

/**
 * @param {number} ms
 * @returns {string}
 */
export function formatDevPlayTimeMs(ms) {
  ms = Math.max(0, Math.floor(Number(ms) || 0));
  var sec = Math.floor(ms / 1000);
  var h = Math.floor(sec / 3600);
  var m = Math.floor((sec % 3600) / 60);
  var s = sec % 60;
  if (h > 0) {
    return h + ":" + String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
  }
  return m + ":" + String(s).padStart(2, "0");
}

/**
 * @param {{ playTimeMs?: number, runIndex?: number }} stats
 * @returns {string}
 */
export function formatDevStatsOverlayText(stats) {
  stats = stats || {};
  var runIndex = Math.max(0, Math.floor(Number(stats.runIndex) || 0));
  return "play " + formatDevPlayTimeMs(stats.playTimeMs) + " · run " + runIndex;
}
